module.exports = __webpack_public_path__ + "img/sylc-bg.7ddcf467.png";